import { isBefore } from 'date-fns';
import { useAtom } from 'jotai';
import { useRouter } from 'next/router';
import React, { useCallback } from 'react';

import { Modal } from '~/components/blocks';
import { useClientAuthUrl } from '~/hooks/use-client_auth-url';
import { useClientAuthSetting } from '~/hooks/use-client-auth-setting';
import { clientAuthenticationModalState } from '~/state/layouts/SharedAppShell/atoms';

import { InstallPanel } from './InstallPanel';
import { IssuePanel } from './IssuePanel';

const IGNORE_PATHNAME = ['/settings/organization/client_certs'];

export const ClientAuthenticationModal = () => {
  const { enable, startAt, hasClientCerts, allInstalled } = useClientAuthSetting();
  const [{ isClosed }, setClientAuthenticationModalState] = useAtom(clientAuthenticationModalState);
  const { pathname } = useRouter();
  const isIgnored = IGNORE_PATHNAME.includes(pathname);
  const clientAuthUrl = useClientAuthUrl();
  const isClientAuthDomain = location.origin === clientAuthUrl;
  const isTransitionPeriod = enable && isBefore(new Date(), startAt || new Date());
  const installCondition = hasClientCerts ? !allInstalled : true;
  // 移行期間、且つ通常ドメインの場合のみ表示する
  // また、店舗に「ダウンロード待ち」「ダウンロード済み」の証明書が存在しない場合は、モーダルを表示しない
  const isOpen = isTransitionPeriod && installCondition && !isClientAuthDomain;
  const _startAt = startAt || new Date();

  const handleClose = useCallback(() => {
    setClientAuthenticationModalState((_state) => ({ ..._state, isClosed: true }));
  }, [setClientAuthenticationModalState]);

  return (
    <Modal open={isOpen && !isClosed && !isIgnored} onClose={handleClose}>
      {hasClientCerts ? (
        <InstallPanel startAt={_startAt} onClosed={handleClose} />
      ) : (
        <IssuePanel startAt={_startAt} onClosed={handleClose} />
      )}
    </Modal>
  );
};
